export const blog_categories_data = [
  {
    key: '1',
    category: 'Education',
    addedOn: '25 May 2024',
    status: 'Active',
  },
  {
    key: '2',
    category: 'Advice',
    addedOn: '24 May 2024',
    status: 'Active',
  },
  {
    key: '3',
    category: 'Academic',
    addedOn: '15 Mar 2024',
    status: 'Active',
  },
  {
    key: '4',
    category: 'Clear Goals',
    addedOn: '21 Feb 2024',
    status: 'Active',
  },
  {
    key: '5',
    category: 'Healthy Education',
    addedOn: '15 Feb 2024',
    status: 'Inactive',
  },
  {
    key: '6',
    category: 'Transport',
    addedOn: '12 Feb 2024',
    status: 'Active',
  },
  {
    key: '7',
    category: 'Hostel',
    addedOn: '14 Jan 2024',
    status: 'Active',
  },
  {
    key: '8',
    category: 'Management',
    addedOn: '12 Jan 2024',
    status: 'Active',
  },
  {
    key: '9',
    category: 'Guidance',
    addedOn: '16 Dec 2023',
    status: 'Inactive',
  },
  {
    key: '10',
    category: 'Sports',
    addedOn: '12 Dec 2023',
    status: 'Active',
  },
  ];